import * as React from 'react';
import classnames from 'classnames';

const ProductDiscountLabel = ({ title , modifier  })=>title ? /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-discount-label', {
            [`product-discount-label--${modifier}`]: !!modifier
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "product-discount-label__title"
    }, title)) : null
;

export { ProductDiscountLabel };
//# sourceMappingURL=ProductDiscountLabel.js.map
